import React from 'react';
import Link from 'next/link';
import Button from '@mui/material/Button';
import { RESUME_EVALUATION_ROUTER_PATH } from '@/constants/router-path';
import { trackClickEvent } from '@/utils/site-track';

const MiddleBanner = () => {
  return (
    <div
      data-observer-id="marketing_middle-banner_evaluation"
      data-ele-group="marketing_banner_evaluation"
      data-ele-id="middle-banner_我的简历能拿到这个薪资吗？"
      className="rounded-lg px-5 py-5 flex flex-col items-center justify-between mt-10 mb-10 bg-web-grey-300 tablet:flex-row tablet:py-10 tablet:px-20 tablet:mt-8"
    >
      <div className="text-base mb-4 tablet:mb-0">
        <p className="text-2xl font-semibold mb-4">
          我的简历能拿到这个薪资吗？
        </p>
        <p className="leading-7">你知道吗？写得好的简历，薪资可能高出 30%。</p>
        <p className="leading-7">
          别让简历拖后腿，一键诊断，看看你的简历能否争取到涨薪的机会。
        </p>
      </div>
      <Button
        className="w-full h-[45px] !font-semibold !tracking-[1px] !bg-web-black-100 tablet:w-[220px]"
        variant="contained"
        color="primary"
        LinkComponent={Link}
        href={RESUME_EVALUATION_ROUTER_PATH}
        onClick={trackClickEvent}
      >
        立即诊断
      </Button>
    </div>
  );
};

export default MiddleBanner;
